import { TextControl } from "@wordpress/components";

export function AudioDescription({ attributes, setAttributes, mode }) {
	if (mode === "player") {
		return (
			<div className={"description-" + mode}>
				<h1>{attributes.playertitle}</h1>
				<h2>
					<label>Artist: </label>
					<span>{attributes.artist}</span>
				</h2>
				<h2>
					<label>Album: </label>
					<span>{attributes.album}</span>
				</h2>
				<h2>
					<label>Caption: </label>
					<span>{attributes.caption}</span>
				</h2>
				<div>
					<label>Description:</label>
					<p>{attributes.description}</p>
				</div>
			</div>
		);
	} else if (mode === "editor") {
		return (
			<div className={"description-" + mode}>
				<h1>{attributes.title}</h1>
				<img src={attributes.image} />
				<div class="content">
					<TextControl
						label="Player Display Title"
						value={attributes.playertitle}
						onChange={(value) => setAttributes({ playertitle: value })}
					/>{" "}
					<h2>
						<label>Duration: </label>
						<span>{attributes.duration}</span>
					</h2>
					<h2>
						<label>Artist: </label>
						<span>{attributes.artist}</span>
					</h2>
					<h2>
						<label>Album: </label>
						<span>{attributes.album}</span>
					</h2>
					<h2>
						<label>Caption: </label>
						<span>{attributes.caption}</span>
					</h2>
					<div>
						<label>Description:</label>
						<p>{attributes.description}</p>
					</div>
				</div>
			</div>
		);
	} else {
		return (
			<div>
				<h2>AudioDescription Error</h2>
				<span>Invalid mode: {mode}</span>
			</div>
		);
	}
}
